module.exports = __webpack_public_path__ + "static/media/4.f62ff701.png";